import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useMarginAccountDisconnectionModalStyle = createUseStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        margin: `${spacing['07']} 0 ${spacing['03']}`,
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        width: 460,
        padding: `${spacing['03']} 0 ${spacing['05']} 0`,
        flexDirection: 'column',
        gap: spacing['05'],
        borderBottom: `1px solid ${color.border.opaque}`,
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 56,
        width: 56,
    },
    text: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        color: color.content.secondary,
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '-0.48px',
    },
    buttonWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginTop: spacing['07'],
        '& button': {
            height: 44,
            width: '100%',
            fontSize: fontSize.md,
        },
    },
});
